<desy-header
  *ngIf="isLogged()"
  [expandedLogo]="false"
  homepageRouterLink="/inicio">
  <desy-header-subnav>Plataforma de Gobernanza</desy-header-subnav>

  <desy-header-navigation>
    <desy-header-navigation-item
      routerLink="/inicio"
      [active]="activeInicio">
      Inicio
    </desy-header-navigation-item>
  </desy-header-navigation>
  <desy-header-dropdown id="procedures">
    <div [ngClass]="{ 'font-bold': isActivePermissionsDropdown }">Gestión de permisos</div>
    <desy-nav>
      <desy-nav-item
        routerLink="/mis-adhesiones/listado/enviadas"
        [active]="activeEnviada || activeRecibida">
        Mis adhesiones
      </desy-nav-item>
      <desy-nav-item
        routerLink="/uso-datos/cedidos"
        [active]="isActiveCedidos() || isActiveAdheridos()">
        Uso de datos de protocolos
      </desy-nav-item>
    </desy-nav>
  </desy-header-dropdown>
  <desy-header-dropdown id="catalog-IA">
    <div [ngClass]="{ 'font-bold': isActiveCatalogIADropdown }">REGSIA</div>
    <desy-nav>
      <desy-nav-item
        routerLink="catalogo-ia/proyectos/listado-proyectos"
        [active]="activeProjects">
        Proyectos IA
      </desy-nav-item>
      <desy-nav-item
        routerLink="catalogo-ia/sistemas-de-ia/listado-sistemas"
        [active]="activeSystemIA">
        Sistemas IA
      </desy-nav-item>
      <desy-nav-item
        routerLink="/catalogo-ia/uso-de-solucion-ia/listado-uso-de-solucion-ia"
        [active]="activeAiSolutionUsage">
        Soluciones IA
      </desy-nav-item>
    </desy-nav>
  </desy-header-dropdown>
  <desy-header-dropdown id="procedures">
    <div [ngClass]="{ 'font-bold': isActiveDataCatalogDropdown }">Catalogación de datos</div>
    <desy-nav>
      <desy-nav-item
        routerLink="#"
        [active]="false"
        [disabled]="true">
        Catálogo de datos
        <!-- Nombre Placeholder -->
      </desy-nav-item>
    </desy-nav>
  </desy-header-dropdown>
  <desy-header-dropdown
    *ngIf="nameUser && nameUser.length > 0"
    style="margin-left: auto">
    Hola, {{ nameUser | uppercaseFirst }}
    <desy-nav>
      <desy-nav-item (clickEvent)="logout()">Cerrar sesión</desy-nav-item>
    </desy-nav>
  </desy-header-dropdown>

  <desy-header-offcanvas>
    <desy-header-offcanvas-button>Menu</desy-header-offcanvas-button>
    <desy-header-offcanvas-close-button>Cerrar</desy-header-offcanvas-close-button>
    <desy-content>
      <ul>
        <li>
          <desy-nav
            [idPrefix]="'nav1'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/inicio"
              [active]="activeInicio"
              [ngClass]="{ 'font-bold': activeInicio }">
              Inicio
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav
            [idPrefix]="'nav2'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/mis-adhesiones/listado/enviadas"
              [active]="activeEnviada || activeRecibida"
              [ngClass]="{ 'font-bold': activeEnviada || activeRecibida }">
              Mis adhesiones
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav
            [idPrefix]="'nav3'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/uso-datos/cedidos"
              [active]="isActiveCedidos() || isActiveAdheridos()"
              [ngClass]="{ 'font-bold': isActiveCedidos() || isActiveAdheridos() }">
              Uso de datos de protocolos
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav
            [idPrefix]="'nav4'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/catalogo-ia/proyectos/listado-proyectos"
              [active]="activeProjects"
              [ngClass]="{ 'font-bold': activeProjects }">
              Proyectos IA
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav
            [idPrefix]="'nav5'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/catalogo-ia/sistemas-de-ia/listado-sistemas"
              [active]="activeSystemIA"
              [ngClass]="{ 'font-bold': activeSystemIA }">
              Sistemas de IA
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav
            [idPrefix]="'nav6'"
            classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item
              routerLink="/catalogo-ia/uso-de-solucion-ia/listado-uso-de-solucion-ia"
              [active]="activeAiSolutionUsage"
              [ngClass]="{ 'font-bold': activeAiSolutionUsage }">
              Soluciones IA
            </desy-nav-item>
          </desy-nav>
        </li>
        <li>
          <desy-nav classes="bg-primary-light/20 menu-responsive">
            <desy-nav-item (clickEvent)="logout()">Cerrar sesión</desy-nav-item>
          </desy-nav>
        </li>
      </ul>
    </desy-content>
  </desy-header-offcanvas>
</desy-header>

<desy-header
  *ngIf="!isLogged()"
  [expandedLogo]="false">
  <desy-header-subnav>Plataforma de Gobernanza</desy-header-subnav>
</desy-header>
